import http from '@/utils/http'

/**
 * 菜品类
*/
export function categoryList() {
    return http({
        method: 'get',
        url: '/business/bizXcwsDrDishLibrarySys/categoryList'
    })
}

/**
 * 文件路径
*/
export function findBaseUrl() {
    return http({
        method: 'get',
        url: '/common/file/baseUrl/find'
    })
}

/**
 * 添加菜品
*/
export function categoryAdd(data) {
    return http({
        method: 'post',
        url: '/business/bizXcwsDrDishLibrarySys/add',
        data
    })
}

/**
 * 编辑菜品
*/
export function categoryEdit(data) {
    return http({
        method: 'post',
        url: '/business/bizXcwsDrDishLibrarySys/update',
        data
    })
}


/**
 * 删除菜品
*/
export function categoryDel(data) {
    return http({
        method: 'post',
        url: '/business/bizXcwsDrDishLibrarySys/delete',
        params: data
    })
}
